import React, { useState } from "react";
import { Container, List, ListItem, ListItemText, Switch } from '@material-ui/core';
import { useStore } from '../Store'
import BottomNavigationCustom from './BottomNavigationCustom'
import { useToaster } from "./Toaster";
import Header from './Header'
import localStorageService from "../services/LocalStorageService";

const SettingsPage = ({ history }) => {

  const { settings, user, logoff, reload } = useStore();
  const { showError, showMessage } = useToaster()
  const [sci, setSci] = useState(localStorageService.getItem('SCI'))

  const handleToggle = () => {
    localStorageService.setItem('SCI', !sci);
    setSci(!sci)
  }

  const handleLogoff = () => {
    logoff()
    history.push('/login')
  }

  const getSetting = async () => {
    try {
      await reload()
      showMessage('Instellingen zijn bijgewerkt.')
    }
    catch (error) {
      if (error.response && error.response.status === 401) history.push('/login')
      showError(error)
    }
  }

  return (
    <>
      <Header title='Instellingen' />
      <Container>
        <List component="nav" aria-label="main mailbox folders">
          <ListItem button divider onClick={getSetting}>
            <ListItemText
              primary="Instellingen bijwerken"
              secondary="Werk bestanden bij zoals telgebieden en soortenlijsten"
            />
          </ListItem>
          {process.env.REACT_APP_PROJECTID === "61" &&
            <ListItem button divider onClick={() => { handleToggle() }}>
              <ListItemText
                primary="Gebruik wetenschappelijke namen"
              />
              <Switch
                edge="end"
                onChange={() => { handleToggle() }}
                checked={sci}
              />
            </ListItem>
          }
          {process.env.REACT_APP_HELPURL &&
            <ListItem button component="a" href={process.env.REACT_APP_HELPURL} target="_blank" divider>
              <ListItemText
                primary="Handleiding gebruik van deze app"
              />
            </ListItem>
          }
          <ListItem button divider onClick={handleLogoff}>
            <ListItemText
              primary="Uitloggen"
              secondary={`Ingelogd onder ${user.username} in portaal ${settings.description}`}
            />
          </ListItem>
          <ListItem divider>
            <ListItemText
              primary="Versie"
              secondary={`${process.env.REACT_APP_BUILD}`}
            />
          </ListItem>
        </List>
      </Container>
      <BottomNavigationCustom />
    </>
  )
}
export default SettingsPage